import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Download, Calendar, Users, TrendingUp, ArrowLeft, FileText, Filter } from 'lucide-react';
import { Button } from '../../components/ui/Button';
import { Card, CardContent, CardHeader, CardTitle } from '../../components/ui/Card';
import { Badge } from '../../components/ui/Badge';
export function ChapterReports() {
  const navigate = useNavigate();
  const [selectedPeriod, setSelectedPeriod] = useState('monthly');
  const reports = [{
    id: 1,
    title: 'Laporan Aktivitas Bulanan',
    date: 'Januari 2025',
    type: 'PDF',
    size: '2.5 MB',
    status: 'Selesai'
  }, {
    id: 2,
    title: 'Laporan Engagement Anggota',
    date: 'Q4 2024',
    type: 'PDF',
    size: '3.2 MB',
    status: 'Selesai'
  }, {
    id: 3,
    title: 'Ringkasan Acara',
    date: 'Desember 2024',
    type: 'Excel',
    size: '1.8 MB',
    status: 'Selesai'
  }, {
    id: 4,
    title: 'Laporan Keuangan Chapter',
    date: 'Januari 2025',
    type: 'PDF',
    size: '-',
    status: 'Proses'
  }];
  const stats = [{
    label: 'Total Anggota',
    value: '245',
    icon: Users,
    color: 'text-atios-primary',
    bgColor: 'bg-atios-light'
  }, {
    label: 'Acara Bulan Ini',
    value: '8',
    icon: Calendar,
    color: 'text-success',
    bgColor: 'bg-success-light'
  }, {
    label: 'Tingkat Pertumbuhan',
    value: '+12%',
    icon: TrendingUp,
    color: 'text-warning',
    bgColor: 'bg-warning-light'
  }];
  const handleDownload = (reportId: number) => {
    alert(`Mengunduh laporan #${reportId}...`);
  };
  const handleGenerate = () => {
    alert('Membuat laporan baru...');
  };
  return <div className="min-h-screen bg-white" data-id="element-1506">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8" data-id="element-1507">
        {/* Header */}
        <div className="mb-8" data-id="element-1508">
          <Button variant="ghost" onClick={() => navigate('/chapter/dashboard')} className="mb-4" data-id="element-1509">
            <ArrowLeft className="w-4 h-4 mr-2" data-id="element-1510" />
            Kembali ke Dasbor
          </Button>
          <div className="flex items-center justify-between" data-id="element-1511">
            <div data-id="element-1512">
              <h1 className="text-3xl font-semibold text-neutral-900 mb-2" data-id="element-1513">
                Laporan Chapter
              </h1>
              <p className="text-neutral-600" data-id="element-1514">
                Lihat dan unduh laporan kinerja chapter
              </p>
            </div>
            <Button onClick={handleGenerate} data-id="element-1515">
              <Download className="w-4 h-4 mr-2" data-id="element-1516" />
              Buat Laporan Baru
            </Button>
          </div>
        </div>

        {/* Stats */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-8" data-id="element-1517">
          {stats.map((stat, i) => <Card key={i} data-id="element-1518">
              <CardContent className="p-6" data-id="element-1519">
                <div className="flex items-center gap-4" data-id="element-1520">
                  <div className={`p-3 rounded-lg ${stat.bgColor}`} data-id="element-1521">
                    <stat.icon className={`w-6 h-6 ${stat.color}`} data-id="element-1522" />
                  </div>
                  <div data-id="element-1523">
                    <h3 className="text-2xl font-semibold text-neutral-900" data-id="element-1524">
                      {stat.value}
                    </h3>
                    <p className="text-sm text-neutral-600" data-id="element-1525">{stat.label}</p>
                  </div>
                </div>
              </CardContent>
            </Card>)}
        </div>

        {/* Period Filter */}
        <div className="mb-6" data-id="element-1526">
          <div className="flex gap-2" data-id="element-1527">
            <Button variant={selectedPeriod === 'daily' ? 'primary' : 'secondary'} onClick={() => setSelectedPeriod('daily')} data-id="element-1528">
              Harian
            </Button>
            <Button variant={selectedPeriod === 'weekly' ? 'primary' : 'secondary'} onClick={() => setSelectedPeriod('weekly')} data-id="element-1529">
              Mingguan
            </Button>
            <Button variant={selectedPeriod === 'monthly' ? 'primary' : 'secondary'} onClick={() => setSelectedPeriod('monthly')} data-id="element-1530">
              Bulanan
            </Button>
            <Button variant={selectedPeriod === 'yearly' ? 'primary' : 'secondary'} onClick={() => setSelectedPeriod('yearly')} data-id="element-1531">
              Tahunan
            </Button>
          </div>
        </div>

        {/* Reports List */}
        <Card data-id="element-1532">
          <CardHeader data-id="element-1533">
            <CardTitle data-id="element-1534">Laporan Tersedia</CardTitle>
          </CardHeader>
          <CardContent data-id="element-1535">
            <div className="space-y-4" data-id="element-1536">
              {reports.map(report => <div key={report.id} className="flex items-center justify-between p-4 border border-neutral-200 rounded-lg hover:border-atios-primary transition-colors" data-id="element-1537">
                  <div className="flex items-center gap-4" data-id="element-1538">
                    <div className="p-3 rounded-lg bg-atios-light" data-id="element-1539">
                      <FileText className="w-5 h-5 text-atios-primary" data-id="element-1540" />
                    </div>
                    <div data-id="element-1541">
                      <h4 className="font-medium text-neutral-900" data-id="element-1542">
                        {report.title}
                      </h4>
                      <p className="text-sm text-neutral-600" data-id="element-1543">
                        {report.date} • {report.type}
                        {report.size !== '-' && ` • ${report.size}`}
                      </p>
                    </div>
                  </div>
                  <div className="flex items-center gap-3" data-id="element-1544">
                    <Badge variant={report.status === 'Selesai' ? 'success' : 'warning'} data-id="element-1545">
                      {report.status}
                    </Badge>
                    <Button variant="secondary" size="sm" disabled={report.status !== 'Selesai'} onClick={() => handleDownload(report.id)} data-id="element-1546">
                      <Download className="w-4 h-4 mr-2" data-id="element-1547" />
                      Unduh
                    </Button>
                  </div>
                </div>)}
            </div>
          </CardContent>
        </Card>
      </div>
    </div>;
}